import { RouteObject } from 'react-router'

import { ROUTES } from '@/common/constants/routes'
import { AuthenticatedLayout } from '@/common/layouts/AuthenticatedLayout'
import { ProfileLayout } from './components/ProfileLayout'
import GeneralData from './pages/GeneralData'
import Password from './pages/Password'
import Preferences from './pages/Preferences'
import ProfileAccess from './pages/ProfileAccess'

export const ProfileRoutes: RouteObject[] = [
  {
    element: <AuthenticatedLayout />,
    children: [
      {
        element: <ProfileLayout />,
        children: [
          {
            path: ROUTES.PROFILE.HOME,
            element: <GeneralData />,
          },
          {
            path: ROUTES.PROFILE.PASSWORD,
            element: <Password />,
          },
          {
            path: ROUTES.PROFILE.PREFERENCES,
            element: <Preferences />,
          },
          {
            path: ROUTES.PROFILE.ACCESS,
            element: <ProfileAccess />,
          },
        ],
      },
    ],
  },
]
